
<div :id="content.idHTML" :class="jel_getClassObject(content)">
  <GroupeRadio v-model="canafe" :content="getContent()"></GroupeRadio>
</div>
